import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as API from '../../api/routes';
import {
  EMOTION_GET_NEWEST,
  EMOTION_GET_DETAILS,
} from '../actions';

import {
  emotionGetNewestSuccessed,
  emotionGetNewestFailed,
  emotionGetDetailsSuccessed,
  emotionGetDetailsFailed,
} from './actions';

function* emotionGetNewest({ callback }) {
  try {
    const res = yield call(API.emotionGetNewest);
    yield put(emotionGetNewestSuccessed(res.result));
    yield call(callback?.(res.result));
  } catch(error) {
    yield put(emotionGetNewestFailed(error.error_message))
  }
}

function* emotionGetDetails({ payload, callback }) {
  try {
    const { user_id } = payload;
    const res = yield call(API.emotionGetDetails, user_id);
    yield put(emotionGetDetailsSuccessed(res.result));
    yield call(callback?.(res.result));
  } catch (error) {
    yield put(emotionGetDetailsFailed(error.error_message));
  }
}

export function* watchWorkers() {
  yield takeEvery(EMOTION_GET_NEWEST, emotionGetNewest);
  yield takeEvery(EMOTION_GET_DETAILS, emotionGetDetails);
}

export default function* rootSaga() {
  yield all([
    fork(watchWorkers)
  ]);
}